module.exports = __webpack_public_path__ + "static/media/omen-analytics-inc.27bda03e.svg";